export default "__VITE_ASSET__CsGJaR3X__"